// deps
import { useContext, useEffect } from "react";

// internal deps
import { isEmpty } from "@swiggy-private/js-utils";
import { SwiggyHeadersContext } from "@swiggy-private/portal-swiggy-one-subscription-context/dist";

// utils
import { getBridgeSdk, normalCloseWebView } from "../utils/bridgeSdk";
import { getSwiggyHeaders } from "utils/headers";

// analytics
import { setLastScreen } from "analytics";

const useGetHomePageData = () => {
    const { swiggyHeaders, setSwiggyHeaders } = useContext(SwiggyHeadersContext);

    useEffect(() => {
        if (!isEmpty(swiggyHeaders) && (isEmpty(swiggyHeaders?.userid) || isEmpty(swiggyHeaders?.tid))) {
            getBridgeSdk()
                .login()
                .then(async (response) => {
                    try {
                        if (!response || !response.hasLoggedIn) {
                            return false;
                        }

                        const headers = await getSwiggyHeaders();
                        setLastScreen(headers?.referrer);

                        if (headers) {
                            setSwiggyHeaders(headers);
                        }
                    } catch (error) {
                        normalCloseWebView();
                    }
                })
                .catch(() => void 0);
        }
    }, [swiggyHeaders, setSwiggyHeaders]);
};

export default useGetHomePageData;
